import { useEffect, useState } from "react";
import { Cookies, useCookies } from "react-cookie";
import CryptoJS from "crypto-js";
import { userLogout } from "../firebase";

export function useTranslate() {
  const cookies = new Cookies();
  const [translateCookies, setTranslateCookies] = useState(() =>
    cookies.get("googletrans")
  );

  useEffect(() => {
    cookies.set("googletrans", translateCookies)
  }, [translateCookies]);

  return [
    translateCookies,
    setTranslateCookies,
  ]
}

const ENCRYPT_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const COOKIES_DOMAIN = process.env.REACT_APP_VERCEL_ENV
  ? process.env.REACT_APP_COOKIES_DOMAIN
  : null;

const ENCRYPT_DATA = (data) => {
  const encrypted = CryptoJS.AES.encrypt(data, ENCRYPT_SECRET_KEY).toString();
  return encrypted;
};

const DECRYPT_DATA = (data) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(data, ENCRYPT_SECRET_KEY).toString(
      CryptoJS.enc.Utf8
    );
    return decrypted;
  } catch (error) {
    return;
  }
};

export const GET_USER_AUTH_TOKEN = () => {
  const cookies = new Cookies();
  const token = cookies.get("GU6IXA");
  return token ? `Bearer ${token}` : "";
};

export const DELETE_COOKIES = () => {
  const cookies = new Cookies();
  cookies.remove("GU6IXA")
  cookies.remove("GU6IX")
}

export function SESSION_AUTH() {
  const cookies = new Cookies();
  const [translateCookies, setTranslateCookies] = useState(() =>
    cookies.get("googtrans")
  );
  const [isUserReinitialize, setIsUserReinitialize] = useState("");
  const [loginSession, setLoginSession, removeLoginSession] = useCookies([
    "GU6IX",
  ]);

  const LOGOUT_USER_SESSION = (user = "") => {
    userLogout(user).then((res) => {
      console.log(res)
    }).finally(() => {
      removeLoginSession("GU6IX", {
        path: "/",
        domain: COOKIES_DOMAIN,
      });
      removeLoginSession("GU6IXA", {
        path: "/",
        domain: COOKIES_DOMAIN,
      });
      for (const cookie in cookies.getAll()) {
        cookies.remove(cookie, {
          path: "/",
          domain: COOKIES_DOMAIN,
        });
      }
      window.location.href = '/'
    })
  };

  const GET_USER_SESSION = () => {
    if (loginSession?.GU6IX) {
      let data = DECRYPT_DATA(loginSession?.GU6IX);
      try {
        data = data ? JSON.parse(data) : "";
        if (data?.uid || data?.userId) {
          return data;
        } else {
          LOGOUT_USER_SESSION();
          return "";
        }
      } catch (err) {
        LOGOUT_USER_SESSION();
        return "";
      }
    }
    return "";
  };

  const [isUserSession, setIsuserSession] = useState(() => GET_USER_SESSION());

  const SET_USER_SESSION = (user) => {
    let data = ENCRYPT_DATA(JSON.stringify(user));
    var expireDate = new Date();
    expireDate.setHours(0, 0, 0, 0);
    expireDate.setDate(expireDate.getDate() + 7);
    setLoginSession("GU6IX", data, {
      sameSite: "strict",
      secure: process.env.REACT_APP_VERCEL_ENV ? true : false,
      expires: expireDate,
      path: "/",
      domain: COOKIES_DOMAIN,
    });
    setLoginSession("GU6IXA", user.authToken, {
      sameSite: "strict",
      secure: process.env.REACT_APP_VERCEL_ENV ? true : false,
      expires: expireDate,
      path: "/",
      domain: COOKIES_DOMAIN,
    });
  };

  const UPDATE_USER_TOKEN = (authToken) => {
    var expireDate = new Date();
    expireDate.setHours(0, 0, 0, 0);
    expireDate.setDate(expireDate.getDate() + 7);
    setLoginSession("GU6IXA", authToken, {
      sameSite: "strict",
      secure: process.env.REACT_APP_VERCEL_ENV ? true : false,
      expires: expireDate,
      path: "/",
      domain: COOKIES_DOMAIN,
    });
  }

  const UPDATE_USER_SESSION = (data = false) => {
    if (data) {
      let user = GET_USER_SESSION();
      for (let key in data) {
        user[key] = data[key];
      }
      SET_USER_SESSION(user);
    }
  };

  useEffect(() => {
    if (loginSession?.GU6IX) {
      let data = DECRYPT_DATA(loginSession?.GU6IX);
      try {
        setIsuserSession(data ? JSON.parse(data) : "");
      } catch (err) {
        setIsuserSession("");
      }
    } else {
      setIsuserSession("");
    }
    setTranslateCookies(loginSession?.googtrans || "");
  }, [loginSession]);

  return {
    isUserSession,
    SET_USER_SESSION,
    UPDATE_USER_SESSION,
    UPDATE_USER_TOKEN,
    LOGOUT_USER_SESSION,
    isUserReinitialize,
    setIsUserReinitialize,
    translateCookies,
    setTranslateCookies,
  };
}
